<template>
    <div class="horizontalSliderContainer">
        <div class="interactionHelp">Slide the dots</div>
        <div class="sliderLabels">
            <div class="leftLabel">{{leftLabel}}</div>
            <div class="rightLabel">{{rightLabel}}</div>
        </div>
        <div v-for="(item, index) in content.rows" :key="index" :class="['value-'+index, 'row']">
            <div class="horizontalSlider">
                <vue-draggable-resizable :id="['dragger'+index]" :w="108" :h="108" :x="400" @dragging="onDrag" :parent="true" :resizable="false" >
                    <div class="grabber">
                        <div class="bg" :text="item">
                            <div class="label">{{item}}</div>
                        </div>
                        <div class="dot"></div>
                    </div>
                </vue-draggable-resizable>
            </div>
        </div>

    </div>
</template>

<script>
import $ from 'jquery'
import VueDraggableResizable from 'vue-draggable-resizable'

export default {
    name: 'HorizontalSlider',
    props: ['value', 'content'],
    mixins: [],
    data() {
        return {
            trackWidth: 799,
            position: null,
            positions: {},
            currentTarget: null
        }
    },

    components: {
        VueDraggableResizable
    },
    ready() {
        
    },
    methods: {
        updateSelection() {
            let vals = {}
            for (let i = 0; i < this.content.rows.length; i++) {
                const el = this.content.rows[i];
                vals[el] = this.positions[el]
            }
            this.$emit('input', vals)
        },
        setTarget(e) {
            let el = $(e.target).find('.bg')
            this.currentTarget = el
        },
        onDrag(x, y) {
            let travelDist = this.trackWidth;
            let trueX = x/travelDist;
            if (trueX < 0) trueX = 0;
            else if (trueX > 1) trueX = 1;
            trueX = Math.round((trueX*4)-2)
            if (trueX == 0) trueX = 0;
            if (this.position != trueX) {
                this.position = trueX;
                if (trueX < 0) {
                    this.currentTarget.addClass('rightText')
                } else {
                    this.currentTarget.removeClass('rightText')
                }
                this.$sound('drip', parseInt(trueX+2))
            }
        },
        getIndex(el) {
            let id = el[0].id
            let index = id[id.length -1];
            let str = this.content.rows[index]
            return str
        },
        snapHandle(e) {
            let destination = Math.abs( ((this.position+2)/4) * this.trackWidth)
            let el = $(e.target).parent()
            let key = this.getIndex(el)
            this.positions[key] = this.position
            this.updateSelection()
            
            let start = el.css('left').split('px')[0]
            var obj = { charged: start };
            this.$anime({
                targets: obj,
                charged: destination,
                duration: 1000,
                elasticity: 750,
                update: () => {
                    el.css('left', obj.charged)
                }
            })
            let inverter = (key == 'water')? -1:1
            let pitch = parseInt(this.position)*inverter
            this.$sound('drop', pitch)
        },
    },

    computed: {
        leftLabel() {
            return this.content.values[0]
        },
        rightLabel() {
            return this.content.values[this.content.values.length-1]
        }
    },

    watch: {
    },

    created() {
    },

    destroyed() {
    },

    mounted() {
        for (let i = 0; i < this.content.rows.length; i++) {
            const el = this.content.rows[i];
            this.positions[el] = 0
        }
        this.$nextTick(() => {
            $(".grabber").on('touchstart mousedown', (e) => {
                this.setTarget(e)
            })
            $(".grabber").on('touchend mouseup', (e) => {
                this.snapHandle(e)
            })
            let mid = 400
            $(".draggable").css('left', mid)
        })
    }

}
</script>

<style lang="scss">
@import "../styles/variables.scss";

.horizontalSliderContainer {
    position: absolute;
    left: 0;
    top: 55vw;
    padding: 0 8vw;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    .interactionHelp {
        font-size: 3.5vw;
        opacity: .35;
        margin-bottom: 22vw;
    }
    .sliderLabels {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        color: $color-white;
        font-family: "Walsheim";
        font-size: 3vw;
        margin-bottom: 2vw;
        text-transform: uppercase;
        letter-spacing: .3vw;
    }
    .horizontalSlider {
        position: relative;
        height: 10vw;
        width: 84vw;
        border-radius: 5vw;
        background-color: rgba($color-darkGreen, .35);
        margin: 2.5vw 0;
        overflow: hidden;
        .bg {
            position: absolute;
            z-index: -1;
            top: 0;
            right: 0;
            bottom: 0;
            width: 100vw;
            border-radius: 5vw;
            background-color: rgba($color-darkGreen, .75);
            padding-right: 12vw;
            pointer-events: none;
            .label {
                text-align: right;
                color: white;
                font-size: 3vw;
                line-height: 9.5vw;
            }
            &.rightText {
                .label {
                    text-align: left;
                    width: 30vw;
                    position: absolute;
                    margin-left: 114vw;
                }
            }
        }
        .grabber {
            position: absolute;
            top: -20;
            left: 0;
            background: $color-darkGreen;
            width: 5vw;
            height: 5vw;
            border-radius: 6vw;
            padding: 2.5vw;
            z-index: 2;
            .dot {
                width: 5vw;
                height: 5vw;
                border-radius: 2.5vw;
                background: $color-white;
                pointer-events: none;
            }
        }
    }
    
}
#surveyContainer .HorizontalSlider input.sv_next_btn {
    position: absolute;
    bottom: 8vw;
    left: 50vw;
    margin-left: -24vw;
}

</style>